function DownloadUrl(url, name) {
  let link = document.createElement('a')
  if (name) link.setAttribute('download', name)
  link.setAttribute('target', '_blank')
  link.href = url
  document.body.appendChild(link)
  link.click()
  link.remove()
}

function Capitalize(val) {
  return val.charAt(0).toUpperCase() + val.substring(1)
}

export { DownloadUrl, Capitalize }
